import { connect } from 'react-redux';
import { createSelector } from 'reselect';
import FrameworkUtils from 'utils/framework';
const { wrapHOC } = FrameworkUtils;

import { isInventoryAwareStorePickerEnabledSelector } from 'viewModel/selectors/shopYourStore/isInventoryAwareStorePickerEnabledSelector';

const fields = createSelector(isInventoryAwareStorePickerEnabledSelector, isInventoryAwareStorePickerEnabled => {
    return {
        isInventoryAwareStorePickerEnabled
    };
});

const withStorePickerWrapperProps = wrapHOC(connect(fields));

export {
    fields, withStorePickerWrapperProps
};
